import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrDownload26asInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'ITR Download 26AS', subtitle: 'Initiate download of Form 26AS for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/download-26as',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-download-26as"
        submitLabel="Download 26AS"
        successSummary="26AS download initiated"
        errorSummary="26AS download failed"
        confirmHeader="Confirm 26AS download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Form 26AS', icon: 'pi-download' }}
    />
);

export default ItrDownload26asInputComponent;
